module.exports = __webpack_public_path__ + "media/silhouette.cd4680d2.png";